module.exports = __webpack_public_path__ + "img/P150T_weapon_146.1479334c.png";